import React, {Component} from 'react'
import {Card, CardBody} from 'reactstrap';
import StdTable from '../StdTable'
import ActionFormModal from '../StdForm/ActionFormModal'
import ProductValidator from '../../validators/Product'
import { Trans } from "react-i18next";
class Products extends Component{
    
    componentDidMount(){
	this.props.getProducts()
    }

    render(){
	    const {products, editProduct, current_user} = this.props
	    const EditProduct = (props) => <ActionFormModal buttonProps = {{ size: "sm"}} action_text={<Trans>products.edit_action</Trans>} trans_prefix="products" fields={[{name: 'title', type: 'text'}, {name: 'price', type: 'number'}, {name: 'downloadable', type: 'checkbox'}]} form_name="edit_product" {...props} submitAction={editProduct} validation={ProductValidator}  />
	    return (	    
	    <Card>
	      <CardBody>
		      <StdTable collection={products} fields={['title', {name:'price', type: 'number'}]}  actions={current_user.info.user_type=="SUPERADMIN" ? [EditProduct] : []} trans_prefix="products" actions_props={['id']} collection_key="id" />
	      </CardBody>
	    </Card>
	    )
    }
}
export default Products
